export const GET_ALL_MULTI_BET_BONUSES = "GET_ALL_MULTI_BET_BONUSES"
export const GET_ALL_MULTI_BET_BONUSES_RESPONSE_SUCCESS =
  "GET_ALL_MULTI_BET_BONUSES_RESPONSE_SUCCESS"
export const CREATE_MULTI_BET_BONUS = "CREATE_MULTI_BET_BONUS"
export const UPDATE_MULTI_BET_BONUS = "UPDATE_MULTI_BET_BONUS"
export const DELETE_MULTI_BET_BONUS = "DELETE_MULTI_BET_BONUS"
